import React from 'react';
import clsx from 'clsx';
import css from './Paragraph.module.css';
import { TextBaseProps } from '../textBase/TextBase';

export interface ParagraphProps extends TextBaseProps {
  small?: boolean;
  underline?: boolean;
  bold?: boolean;
}

const Paragraph: React.FC<ParagraphProps> = (props: ParagraphProps) => {
  return (
    <span
      className={clsx(
        css.textParagraph,
        props.small ? css.textParagraphSmall : null,
        props.underline ? css.textUnderlined : null,
        props.bold ? css.textBold : null,
        props.className
      )}
    >
      {props.text}
    </span>
  );
};

export default Paragraph;
